import { useEffect, useRef } from 'react'

/**
 * HTMLノードの幅を算出
 *
 * @param {HTMLElement} node
 * @returns {[number, number]} Width/height
 */
export const calculateNodeDimensions = (node) => {
  const { height, width } = node.getBoundingClientRect()
  const dpr = window.devicePixelRatio
  return [width, height].map((e) => e * dpr).map(Math.floor)
}

/**
 * HTMLノードのCSS変数を追加
 *
 * @param {HTMLElement} node
 * @param {string} CSS変数名
 * @param {string} 値
 * @returns {void}
 */
export const setCssVariable = (node, variableName, value) => {
  node.style.setProperty(variableName, value)
}

/**
 * @function useBlur
 * @param {function():void} handleBlur
 */
export const useBlur = (handleBlur) => {
  const ref = useRef(null)

  useEffect(() => {
    const controller = new AbortController()

    const handleMouseDown = (e) => {
      if (ref.current?.contains(e.target)) handleBlur?.()
    }

    document.addEventListener('mousedown', handleMouseDown, { signal: controller.signal })

    return () => controller.abort()
  }, [])

  return ref
}

/**
 * @function useModifyClassList
 * @param {string} HTMLElementのセレクター
 * @param {string[]} クラスの配列
 */
export const useModifyClassList = (selector, classList) => {
  const addToClassList = () => {
    const element = document.querySelector(selector)
    element.classList.add(...classList)
  }

  const removeFromClassList = () => {
    const element = document.querySelector(selector)
    setTimeout(() => {
      element.classList.remove(...classList)
    }, 400)
  }

  /**
   * @function promisify 追加後、外す処理
   * @param {function(function, function):unknown} cbk リゾルバーは何も返却しない
   */
  const promisify = async (cbk) => {
    addToClassList()

    await new Promise((resolve, reject) => {
      return cbk(resolve, reject)
    }).finally(() => {
      removeFromClassList()
    })
  }

  return {
    promisify,
    addToClassList,
    removeFromClassList
  }
}
